import type { ReactNode } from "react";

import { cn } from "@/lib/cn";
import type { ModalContentType } from "@/types";
import { useModalStore } from "@/ui-state";

export const closeButtonByType = (
  type: ModalContentType
): ReactNode | undefined => {
  switch (type) {
    case "personal-data": {
      return (
        <button className="sdkui:sr-only" disabled type="button">
          Закрыть
        </button>
      );
    }
    default: {
      return;
    }
  }
};

export const classNameByType = (type: ModalContentType) =>
  // sdkui:rounded-lg дополняет класс в modal, которая находится в ui-kit (sm:rounded)
  // width указаны через important для фикса модалки с персональными данными, чтобы не сломать другие modal
  cn(
    type === "personal-data" &&
      "sdkui:max-w- sdkui:max-h-[80%] sdkui:w-[calc(100%_-_30px)]! sdkui:max-w-169! sdkui:overflow-y-auto sdkui:rounded-lg sdkui:px-4 sdkui:py-10",
    "sdkui:max-w-none sdkui:sm:w-auto"
  );

export const canCloseByType = (type: ModalContentType) => {
  const { close } = useModalStore.getState();

  switch (type) {
    case "personal-data": {
      return () => undefined;
    }
    default: {
      return close;
    }
  }
};
